<template>
  <el-card
    class="box-card"
    body-style="padding:0; height:100vh"
    style="min-height: 100vh"
  >
    <div style="display: flex; height: 100%">
      <el-menu
        default-active="config"
        class="el-menu-vertical-demo menu-vertical-enlaces"
        :collapse="true"
        v-if="$route.params.id"
      >
        <el-menu-item index="config" style="width: 60px" @click="sidebar = 'config'">
          <i class="el-icon-setting" />
          <template #title>Configuracion</template>
        </el-menu-item>
        <el-menu-item index="users" style="width: 60px" @click="sidebar = 'users'">
          <i class="el-icon-user" />
          <template #title>Usuarios</template>
        </el-menu-item>
      </el-menu>
      <div class="p-5 custom-scroll" style="width: 100%; height: 100%; overflow: auto">
        <div style="display: flex; justify-content: space-between">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db }"
              >Panel</el-breadcrumb-item
            >
            <el-breadcrumb-item
              :to="{
                path: '/dashboard/' + $route.params.db + '/plugins/avisos',
              }"
              >Justificacion Nominas</el-breadcrumb-item
            >
            <el-breadcrumb-item v-if="$route.params.id"
              >Editando Documento</el-breadcrumb-item
            >
            <el-breadcrumb-item v-else>Nuevo Documento</el-breadcrumb-item>
          </el-breadcrumb>
          <el-button style="border: unset; padding: 0" @click="init()"
            ><i class="el-icon-refresh" style="color: green; font-size: 20px"
          /></el-button>
        </div>
        <div v-if="sidebar == 'config'" style="width: 100%">
          <div class="loading" v-loading="true" v-if="loading"></div>

          <el-form
            v-if="!loading"
            @submit.native.prevent="submit"
            ref="form"
            label-position="top"
            id="form"
            class="mt-4"
          >
            <el-row>
              <el-col :span="6">
                <el-form-item label="Fecha/mes del documento">
                  <el-date-picker
                    v-model="form.document_date"
                    placeholder="Fecha/mes del documento"
                    size="small"
                    type="month"
                    format="MM/yyyy"
                    value-format="yyyy-MM-dd"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="18">
                <el-form-item label="Nombre del documento">
                  <el-input v-model="form.name" size="small"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="Fecha de envio">
                  <el-date-picker
                    v-model="form.cron_date"
                    placeholder="Fecha de envio a los usuarios"
                    size="small"
                    format="dd/MM/yyyy"
                    value-format="yyyy-MM-dd"
                    type="date"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="18">
                <el-form-item label="Empresa">
                  <el-select
                    v-model="form.company_id"
                    placeholder="Empresa"
                    size="small"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in companies"
                      :key="item.id"
                      :label="item.text"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="mb-5">
              <el-col>
                <el-form-item label="Destinatarios">
                  <app-modal-add-auth
                    :table="tableAuth"
                    :data="idAuth"
                    v-if="showPermisos"
                  ></app-modal-add-auth>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <button
                  type="submit"
                  class="el-button el-button--primary ml-3 el-button--small"
                  style="float: right"
                  form="form"
                >
                  <span>Guardar</span>
                </button>

                <el-button
                  size="small"
                  v-if="!$route.params.section_id"
                  @click="close()"
                  class="ml-3"
                  style="float: right"
                  >Cancelar</el-button
                >

                <el-popover placement="top" title="Enviar" width="200" trigger="click">
                  <div style="display: flex; flex-direction: column; gap: 9px">
                    <el-button
                      size="small"
                      type="danger"
                      v-loading="sendLoading"
                      @click="sendEmails('all')"
                      >A todos</el-button
                    >
                    <el-button
                      size="small"
                      type="info"
                      style="margin-left: 0px"
                      v-loading="sendLoading"
                      @click="sendEmails('toSend')"
                      >No enviado</el-button
                    >
                    <el-button
                      size="small"
                      style="margin-left: 0px"
                      type="warning"
                      @click="sendEmails('needToConfirm')"
                      v-loading="sendLoading"
                      >No aceptado</el-button
                    >
                  </div>
                  <template #reference>
                    <el-button
                      v-if="$route.params.id"
                      type="warning"
                      style="float: right"
                      size="small"
                    >
                      <i class="fa fa-envelope" style="font-size: 13px" /> Enviar
                    </el-button>
                  </template>
                </el-popover>
                <el-button
                  @click="getDocument()"
                  type="info"
                  size="small"
                  :loading="document_download_loading"
                  >Descargar documento</el-button
                >
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div v-if="sidebar == 'users'" style="width: 100%; height: 100%">
          <div
            v-if="new Date(form.cron_date).getTime() > new Date().getTime()"
            style="
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              align-content: center;
              height: 100%;
            "
          >
            <i class="el-icon-date" style="font-size: 100px; color: #d61935" />
            <h3>
              El aviso/justificacion se enviara el {{ dateFormat(form.cron_date) }},
              cuando se envie apareceran datos.
            </h3>
          </div>
          <el-table v-else :data="send_users">
            <el-table-column prop="all_name" label="Nombre" sortable> </el-table-column>
            <el-table-column prop="checked" label="Justificado" width="220" sortable>
              <template slot-scope="scope">
                <div style="display: flex">
                  <el-tag
                    v-if="scope.row.checked == 1"
                    type="success"
                    style="width: 40px; text-align: center"
                    disable-transitions
                    >Si</el-tag
                  >
                  <el-tag
                    v-else
                    type="danger"
                    disable-transitions
                    style="width: 40px; text-align: center"
                    >No</el-tag
                  >
                  <el-button
                    size="small"
                    type="warning"
                    :disabled="scope.row.checked == 1"
                    class="ml-2"
                    @click="sendEmails('needToConfirm', scope.row.user_id)"
                  >
                    <i
                      class="fa fa-envelope"
                      style="font-size: 13px"
                    />Notificar</el-button
                  >
                  <el-button
                    size="small"
                    type="danger"
                    class="ml-2 p-1"
                    @click="delteUser(scope.row.id)"
                  >
                    <i class="fa fa-trash mr-0" style="font-size: 13px"
                  /></el-button>
                </div>
              </template>
            </el-table-column>
            <template #empty>
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  align-content: center;
                  height: 100%;
                "
              >
                <i class="el-icon-warning" style="font-size: 100px; color: #d61935" />
                <h3>
                  Parece que ha ocurrido un error al enviar la justificacion a los
                  usuarios o no hay ningun usuario con esos permisos.
                </h3>
              </div>
            </template>
          </el-table>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import notificationform from "@/components/Dashboard/home/notificationform";
import addAuth from "@/components/_commons/auth/addAuth";

import ApiService from "@/common/api.service";
import { INTRANET_URL, API_UPLOADS } from "@/common/config";
import { mapGetters } from "vuex";
import moment from "moment-timezone";

import {
  FECTH_TIPO_TEMPLATE_DESKTOP,
  FECTH_PAGINA_ACTIVA,
  FECTH_PAGE,
} from "@/store/actions.type";
import { SET_TIPO_TEMPLATE_DESKTOP } from "@/store/mutations.type";

export default {
  name: "NotificacionesForm",
  components: {
    "app-notification-form": notificationform,
    "app-modal-add-auth": addAuth,
  },
  async created() {
    this.init();
    this.showPermisos = true;
    this.$root.$on("guardarPermisos", (frm) => {
      this.frm_permisos = frm;
      if (this.$route.params.id === undefined) {
        this.$notify({
          title: "Success",
          message:
            "Se han almacenado los permisos una vez que guardes el Formulario se subiran",
          type: "success",
          position: "top-right",
        });
      } else {
        this.guardarPermisos();
      }
    });
  },
  data() {
    return {
      loading: true,
      tipos: [],
      frm_permisos: [],
      idAuth: 0,
      tableAuth: "justificacion_nominas",
      showPermisos: false,
      dias: [],
      reload_table: 0,
      show_procesar: false,
      reload_upload: 0,
      showEditPermisos: true,
      showTabla: false,
      id: null,
      form: {
        name: null,
        document_date: null,
        cron_date: null,
        company_id: null,
      },
      companies: [],
      send_users: [],
      sidebar: "config",
      sendLoading: false,
      document_download_loading: false,
    };
  },
  methods: {
    async init() {
      this.loading = true;
      this.idAuth = parseInt(this.$route.params.id);
      await this.getCompanies();
      if (this.$route.params.id !== undefined) {
        await this.getDesktop();
        await this.getUsers();
      }
      this.showPermisos = true;
      this.loading = false;
    },
    async getDesktop() {
      const response = await ApiService.post("dashboard/table", {
        table: "justificacion_nominas",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.$route.params.id,
      });
      this.form = response.data;
    },
    async getUsers() {
      const response = await ApiService.post(
        "dashboard/plugin/justificacion-nominas/get-users/" + this.$route.params.id,
        {
          table: "justificacion_nominas",
          token: localStorage.getItem("token"),
          project_id: localStorage.getItem("table"),
        }
      );
      this.send_users = response.data.map((r) => {
        r.all_name = r.name + " " + r.last_name;
        return r;
      });
    },
    handleRemove(file) {
      this.documento = [];
      this.form.documento = "";
    },
    handleChange(file) {
      console.log([file]);
      this.documento = [{ file, field: "documento" }];
    },
    handlePreview(file) {
      window.open(file.url, "_blank");
    },

    async enviar() {
      const response = await ApiService.post("dashboard/editform", {
        table: "justificacion_nominas",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.form,
        id: this.$route.params.id,
      });
      let id = response.data;
      if (this.$route.params.id) {
        id = this.$route.params.id;
      }

      if (this.frm_permisos.length > 0 && this.$route.params.id === undefined) {
        const resp = await ApiService.put("dashboard/update-desktop-auth", {
          table: "justificacion_nominas",
          token: localStorage.getItem("token"),
          project_id: localStorage.getItem("table"),
          form: this.frm_permisos,
          id: id,
          tableAuth: "justificacion_nominas",
        });

        if (resp.data) {
          this.$notify({
            title: "Success",
            message: "Permisos actualizados",
            type: "success",
            position: "top-right",
          });
        }
      }
      if (this.$route.params.id) {
        this.$notify({
          title: "Success",
          message: "Se ha actualizado el Aviso",
          type: "success",
          position: "top-right",
        });
      } else {
        this.$notify({
          title: "Success",
          message: "Se ha creado el Aviso",
          type: "success",
          position: "top-right",
        });
      }
      this.$router.replace(
        "/dashboard/" + this.$route.params.db + "/justificacion_nominas"
      );
    },
    async guardarPermisos() {
      const resp = await ApiService.put("dashboard/update-desktop-auth", {
        table: "justificacion_nominas",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        form: this.frm_permisos,
        id: this.$route.params.id,
        tableAuth: "justificacion_nominas",
      }).then((response) => {
        if (response.data) {
          this.$notify({
            title: "Success",
            message: "Permisos actualizados",
            type: "success",
            position: "top-right",
          });
        }
      });
    },
    async submit() {
      this.$confirm(
        "Esta acción creara/modificara un nuevo documento ¿Estas seguro?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {
          this.enviar();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Se ha cancelado la modificación.",
          });
        });
    },

    async close() {
      await this.$router.replace(
        "/dashboard/" + this.$route.params.db + "/justificacion_nominas"
      );
    },

    async getCompanies() {
      const a = await ApiService.post("dashboard/listtable", {
        table: "installations",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        header: [
          {
            title: "#id",
            label: "#id",
            path: "id",
            prop: "id",
            type: "number",
            options: [],
          },
          {
            title: "Text",
            label: "Text",
            path: "text",
            prop: "text",
            type: "text",
            options: [],
          },
        ],
      });
      this.companies = a.data;
    },
    async sendEmails(type, user = undefined) {
      const response = await ApiService.post(
        "dashboard/plugin/justificacion-nominas/send-emails/" + this.$route.params.id,
        {
          token: localStorage.getItem("token"),
          project_id: localStorage.getItem("table"),
          type: type,
          user: user,
        }
      );

      this.$notify({
        title: user === undefined ? "Emails enviados" : "Email enviado",
        message:
          user === undefined
            ? "Se han enviado los emails a los usuarios"
            : "Se ha enviado el email al usuario",
        type: "success",
        position: "top-right",
      });
    },

    async getDocument() {
      this.document_download_loading = true;
      const response = await ApiService.post(
        "dashboard/plugin/justificacion-nominas/get-document/" + this.$route.params.id,
        {
          token: localStorage.getItem("token"),
          project_id: localStorage.getItem("table"),
        }
      );
      let a = document.createElement("a");
      a.href = "data:application/octet-stream;base64," + response.data;
      a.download = this.form.name + ".pdf";
      a.click();
      this.document_download_loading = false;
    },
    dateFormat(date) {
      return moment(date).tz("Europe/Madrid").format("DD/MM/Y");
    },
    async delteUser(id) {
      this.$confirm(
        "Esto eliminará este usuario de la justificacion. ¿Continuar?",
        "Warning",
        {
          confirmButtonText: "Eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
        }
      )
        .then(async () => {
          const response = await ApiService.post(
            "dashboard/plugin/justificacion-nominas/delete-user/" + id,
            {
              token: localStorage.getItem("token"),
              project_id: localStorage.getItem("table"),
            }
          );
          await this.init();
          this.$notify({
            title: "Usuario eliminado",
            message: "Se ha eliminado correctamente al usuario de la justificaion.",
            type: "success",
            position: "top-right",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "No se ha borrado el usuario de la justificacion",
          });
        });
    },
  },
};
</script>
<style>
.disabled {
  background-color: #dcdfe6;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/justificacion_nominas/form.vue